/* cl-pdp2 — devolve COMPORTAMENTO aos interativos copiados do concorrente na
   pagina de produto. O markup dele veio junto no clone; o JS nao. Sem isto o
   acordeao de FAQ nao abre, o acordeao de "No Designer Markup" nao abre, os
   videos de UGC nao tocam, o carrossel nao anda e os dois popups (Fair Pricing
   e "Find my perfect size") ficam mortos.

   Escopo: so classes que existem na PDP. Delegacao no document para sobreviver
   ao `shopify:section:load` do theme editor e ao re-render do carrinho. */
(function () {
  'use strict';

  var bound = false;

  /* ---------------------------------------------------------- acordeoes
     Dois markups diferentes, mesma mecanica: o item ganha `.active` e o painel
     recebe max-height em px (o CSS copiado anima `max-height` a partir de 0).
     Altura em px — nao `none` — porque a transicao do concorrente depende disso. */
  var ACCORDIONS = [
    { head: '.accordion-header',           item: '.accordion-item',                  body: '.accordion-content' },
    { head: '.kv-markup-accordion-header', item: '.kv-design-markup-accordion-item', body: '.kv-markup-accordion-content' }
  ];

  function panelHeight(body) {
    // +40px de folga cobrem o padding que o estado `.active` acrescenta
    return body.scrollHeight + 40;
  }

  function setOpen(item, body, open) {
    item.classList.toggle('active', open);
    body.style.maxHeight = open ? panelHeight(body) + 'px' : '';
    if (!open) return;
    // imagem dentro do painel muda a altura depois de carregar
    body.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        if (item.classList.contains('active')) body.style.maxHeight = panelHeight(body) + 'px';
      }, { once: true });
    });
  }

  function onAccordionClick(e) {
    for (var i = 0; i < ACCORDIONS.length; i++) {
      var cfg = ACCORDIONS[i];
      var head = e.target.closest && e.target.closest(cfg.head);
      if (!head) continue;
      var item = head.closest(cfg.item);
      var body = item && item.querySelector(cfg.body);
      if (!item || !body) return;
      e.preventDefault();
      var willOpen = !item.classList.contains('active');
      // o concorrente mantem UM item aberto por grupo
      item.parentElement.querySelectorAll(cfg.item).forEach(function (other) {
        if (other === item) return;
        var ob = other.querySelector(cfg.body);
        if (ob) setOpen(other, ob, false);
      });
      setOpen(item, body, willOpen);
      head.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }
  }

  /* Item que ja nasce `.active` no HTML copiado carrega o max-height fixo do
     concorrente (620px). Recalcular com a nossa altura real. */
  function primeAccordions() {
    ACCORDIONS.forEach(function (cfg) {
      document.querySelectorAll(cfg.item + '.active').forEach(function (item) {
        var body = item.querySelector(cfg.body);
        if (body) setOpen(item, body, true);
      });
      document.querySelectorAll(cfg.head).forEach(function (h) {
        if (h.hasAttribute('aria-expanded')) return;
        var it = h.closest(cfg.item);
        h.setAttribute('aria-expanded', it && it.classList.contains('active') ? 'true' : 'false');
      });
    });
  }

  /* ------------------------------------------------------------- videos
     Grade "Join 350,000+ Others": <video muted playsinline> + botao de play.
     Um de cada vez, como no concorrente. */
  function markPlaying(video, playing) {
    var wrap = video.closest('.video-wrapper');
    if (!wrap) return;
    wrap.classList.toggle('is-playing', playing);
    var ctl = wrap.querySelector('.video-controls');
    if (ctl) ctl.style.opacity = playing ? '0' : '';
  }

  /* `preload="metadata"` carrega a duracao mas nao PINTA quadro nenhum: a grade
     de UGC ficava com 5 retangulos em branco atras do botao de play. Pedir
     0.1s forca o browser a desenhar o primeiro quadro como "poster". */
  function primeVideoPosters() {
    document.querySelectorAll('.product-videos video').forEach(function (v) {
      if (v.dataset.clPoster === '1') return;
      v.dataset.clPoster = '1';
      var seek = function () {
        try { if (v.currentTime < 0.05) v.currentTime = 0.1; } catch (err) {}
      };
      if (v.readyState >= 1) seek();
      else v.addEventListener('loadedmetadata', seek, { once: true });
    });
  }

  function onVideoClick(e) {
    var hit = e.target.closest && e.target.closest('.play-pause-btn, .video-wrapper');
    if (!hit) return;
    var wrap = hit.closest('.video-wrapper');
    var video = wrap && wrap.querySelector('video');
    if (!video) return;
    e.preventDefault();
    if (video.paused) {
      document.querySelectorAll('.video-wrapper video').forEach(function (v) {
        if (v !== video && !v.paused) { v.pause(); markPlaying(v, false); }
      });
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
      markPlaying(video, true);
    } else {
      video.pause();
      markPlaying(video, false);
    }
  }

  /* ----------------------------------------------------------- carrossel
     Os `.swiper` do concorrente vem com `overflow:hidden` e sem o JS dele: nem
     arrasto, nem roda, nem seta. `cl-slider.js` ja liga as SETAS; estes
     carrosseis (benefits, videos) nao tem seta nenhuma, so barra de progresso.
     Aqui o proprio container vira arrastavel por ponteiro, mantendo o
     `overflow` intocado (trocar para `auto` mexeria no layout — ver
     o comentario em cl-slider.js). */
  function slideStep(sw) {
    var wrap = sw.querySelector('.swiper-wrapper');
    var first = wrap && wrap.firstElementChild;
    if (!first) return sw.clientWidth;
    var r = first.getBoundingClientRect();
    return r.width + (parseFloat(getComputedStyle(first).marginRight) || 0);
  }

  /* barra de progresso do Swiper (`scaleX`) — sem ela o carrossel anda e o
     indicador fica parado */
  function progress(sw) {
    var fill = sw.querySelector('.swiper-pagination-progressbar-fill');
    if (!fill) return;
    var max = sw.scrollWidth - sw.clientWidth;
    var visible = Math.min(1, sw.clientWidth / sw.scrollWidth);
    var pos = max > 0 ? sw.scrollLeft / max : 0;
    fill.style.transform = 'translate3d(' + (pos * (1 - visible) * 100).toFixed(3) +
                           '%, 0px, 0px) scaleX(' + visible.toFixed(4) + ') scaleY(1)';
  }

  function snap(sw) {
    var step = slideStep(sw);
    if (!step) return;
    sw.scrollTo({ left: Math.round(sw.scrollLeft / step) * step, behavior: 'smooth' });
  }

  /* `nativeScroll` = o container JA rola sozinho (a galeria do Shrine e
     `overflow-x:auto` + `scroll-snap`). Nesses, nao mexemos em `touch-action`
     (senao o swipe de dedo morria) nem no snap (o CSS ja faz). */
  function wireDrag(sw, nativeScroll) {
    if (sw.dataset.clDrag === '1') return;
    var wrap = nativeScroll ? sw : sw.querySelector('.swiper-wrapper');
    if (!wrap || wrap.children.length < 2) return;
    // nada a rolar: com 3 cards o carrossel CABE no container (o do concorrente
    // tambem — mesma geometria, 1040x1040). So volta a valer se a janela
    // encolher, e o listener de resize la embaixo re-tenta.
    if (sw.scrollWidth <= sw.clientWidth + 4) return;
    sw.dataset.clDrag = '1';
    sw.style.cursor = 'grab';
    if (!nativeScroll) sw.style.touchAction = 'pan-y';

    // O card e quase todo <img>: comecar o arrasto em cima de uma imagem
    // disparava o DRAG NATIVO do browser, que engole a sequencia de pointer e
    // o carrossel nao saia do lugar. Desligar o drag nativo e capturar o
    // ponteiro resolve os dois lados.
    sw.querySelectorAll('img, a').forEach(function (el) { el.setAttribute('draggable', 'false'); });
    sw.addEventListener('dragstart', function (e) { e.preventDefault(); });

    var down = false, startX = 0, startScroll = 0, moved = 0, pid = null;
    sw.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      // container que ja rola sozinho + dedo: deixa o browser fazer, senao o
      // nosso arrasto brigaria com o scroll nativo (notebook com tela sensivel)
      if (nativeScroll && e.pointerType === 'touch') return;
      down = true; moved = 0; pid = e.pointerId;
      startX = e.clientX; startScroll = sw.scrollLeft;
      sw.style.cursor = 'grabbing';
      // Dois freios do tema atuam a cada atribuicao de scrollLeft e faziam a
      // galeria parecer estatica: `scroll-snap-type: x mandatory` reancorava no
      // slide atual, e `scroll-behavior: smooth` ANIMAVA cada passo, entao o
      // arrasto de 440px avancava 25px. Soltar os dois durante o gesto.
      if (nativeScroll) {
        sw.style.scrollSnapType = 'none';
        sw.style.scrollBehavior = 'auto';
      }
      if (e.pointerType !== 'touch') {
        e.preventDefault();                       // mata a selecao e o drag da imagem
        try { sw.setPointerCapture(pid); } catch (err) {}
      }
    });
    sw.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) <= 3) return;
      moved = Math.abs(dx);
      sw.scrollLeft = startScroll - dx;
      if (e.cancelable) e.preventDefault();
    });
    var end = function () {
      if (!down) return;
      down = false;
      sw.style.cursor = 'grab';
      if (pid !== null) {
        try { sw.releasePointerCapture(pid); } catch (err) {}
        pid = null;
      }
      if (nativeScroll) {
        // encaixa no slide mais proximo e devolve o snap do tema
        var step = sw.firstElementChild ?
          sw.firstElementChild.getBoundingClientRect().width : sw.clientWidth;
        var target = step ? Math.round(sw.scrollLeft / step) * step : sw.scrollLeft;
        sw.style.scrollSnapType = '';
        sw.style.scrollBehavior = '';
        sw.scrollTo({ left: target, behavior: 'smooth' });
      } else {
        snap(sw);
      }
    };
    sw.addEventListener('pointerup', end);
    sw.addEventListener('pointercancel', end);
    sw.addEventListener('lostpointercapture', end);
    // arrasto nao pode virar clique (abriria o video / seguiria o link)
    sw.addEventListener('click', function (e) {
      if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; }
    }, true);
    // roda horizontal (trackpad) — nao interceptar o scroll vertical da pagina
    sw.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      sw.scrollLeft += e.deltaX;
      e.preventDefault();
    }, { passive: false });
    sw.addEventListener('scroll', function () { progress(sw); });
    progress(sw);
  }

  /* --------------------------------------------- rotulo do seletor de tamanho
     O valor da opcao no catalogo e a string inteira
     ("EU 38 - US Women 7 - US Men 5"). Em pills nativas isso viraria 13 botoes
     enormes; o concorrente mostra so o numero e um seletor EU / US W / US M.
     Aqui o TEXTO do rotulo e reescrito (o `value` do radio fica intacto, entao
     o form nativo continua mandando a variante certa) e o seletor de unidade e
     injetado uma vez por grupo. */
  var SIZE_RE = /^\s*EU\s*([^-]+?)\s*(?:-\s*US\s*Women\s*([^-]+?))?\s*(?:-\s*US\s*Men\s*(.+?))?\s*$/i;
  var UNITS = [
    { key: 'eu', label: 'EU', idx: 1 },
    { key: 'usw', label: 'US W', idx: 2 },
    { key: 'usm', label: 'US M', idx: 3 }
  ];

  function parseSize(value) {
    var m = SIZE_RE.exec(value || '');
    return m ? m : null;
  }

  function renderSizeLabels(group, unit) {
    var u = UNITS.filter(function (x) { return x.key === unit; })[0] || UNITS[0];
    group.querySelectorAll('input[type="radio"]').forEach(function (input) {
      var m = parseSize(input.value);
      if (!m) return;
      var label = group.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]');
      if (!label) return;
      var txt = (m[u.idx] || m[1] || '').trim();
      var first = label.firstChild;
      if (first && first.nodeType === 3) first.nodeValue = txt;
      else label.insertBefore(document.createTextNode(txt), label.firstChild);
      label.title = input.value;
    });
    group.querySelectorAll('select option').forEach(function (opt) {
      var m = parseSize(opt.value);
      if (!m) return;
      opt.textContent = (m[u.idx] || m[1] || '').trim();
    });
    group.querySelectorAll('.cl-size-unit').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-unit') === u.key);
    });
  }

  function wireSizePills(group) {
    if (group.dataset.clSize === '1') return;
    var values = Array.prototype.map.call(
      group.querySelectorAll('input[type="radio"], select option'), function (n) { return n.value; });
    var parsed = values.map(parseSize).filter(Boolean);
    if (!parsed.length) return;
    group.dataset.clSize = '1';
    group.classList.add('cl-size-group');

    var has = { eu: true, usw: parsed.some(function (m) { return m[2]; }),
                usm: parsed.some(function (m) { return m[3]; }) };
    if (has.usw || has.usm) {
      var bar = document.createElement('div');
      bar.className = 'cl-size-units';
      UNITS.forEach(function (u) {
        if (!has[u.key]) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cl-size-unit' + (u.key === 'eu' ? ' is-active' : '');
        b.setAttribute('data-unit', u.key);
        b.textContent = u.label;
        bar.appendChild(b);
      });
      var anchor = group.querySelector('.product-form__label-container') || group.firstElementChild;
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(bar, anchor.nextSibling);
      else group.insertBefore(bar, group.firstChild);
    }
    renderSizeLabels(group, 'eu');
  }

  function onUnitClick(e) {
    var b = e.target.closest && e.target.closest('.cl-size-unit');
    if (!b) return;
    e.preventDefault();
    var group = b.closest('.cl-size-group');
    if (group) renderSizeLabels(group, b.getAttribute('data-unit'));
  }

  /* ------------------------------------------ Duo/Single -> quantidade real
     O app Kaching Bundles injeta um `<input type="hidden" name="quantity"
     value="1">` DENTRO do form de produto e monta o payload do ATC a partir
     dele. As barras Duo/Single do bloco nativo `quantity_selector` sao radios
     `name="quantity"` ligados ao form pelo atributo `form=`, entao o Duo era
     enviado como 1 par. Espelhar a escolha no hidden resolve para QUALQUER um
     que monte o payload (o app, o `product-form` do tema ou a nossa gaveta). */
  function syncQuantity(value) {
    document.querySelectorAll('form[action*="/cart/add"] input[type="hidden"][name="quantity"]')
      .forEach(function (h) { h.value = value; });
  }

  function currentQuantity() {
    var r = document.querySelector('input[type="radio"][name="quantity"]:checked');
    return r ? r.value : null;
  }

  function onQuantityChange(e) {
    var r = e.target.closest && e.target.closest('input[type="radio"][name="quantity"]');
    if (!r) return;
    syncQuantity(r.value);
  }

  var SLIDERS = '[class*="cl-sec-"] .swiper, .product-videos .swiper, .cl-pdp-part .swiper';
  var sizeWatch = null;

  /* `wireDrag` desiste quando o carrossel ainda CABE no container. No boot isso
     e comum e enganoso: as fotos dos cards ainda nao tem tamanho, entao o
     `scrollWidth` mede menos do que sera. Sem re-avaliar, o carrossel nascia
     morto em parte dos produtos (e so em parte — dependia de a foto ter ou nao
     chegado do cache). Um ResizeObserver por carrossel resolve os dois casos:
     imagem que carrega depois e janela que encolhe. */
  /* A galeria do produto e nativa do Shrine: no dedo ela ja desliza
     (overflow-x:auto), mas no MOUSE nao havia arrasto e as setas do tema nascem
     escondidas — sobrava a miniatura e a roda horizontal, e a galeria parecia
     estatica. O concorrente usa Flickity, que arrasta. Devolvemos o arrasto so
     onde o ponteiro e fino, para nao roubar o swipe do dedo. */
  var FINE = !window.matchMedia || window.matchMedia('(pointer: fine)').matches;
  var NATIVE_SLIDERS = '[id^="MainProduct-"] .product__media-list, [id^="MainProduct-"] .thumbnail-list';

  function wireSliders() {
    var els = document.querySelectorAll(SLIDERS);
    els.forEach(function (el) { wireDrag(el); });
    if (FINE) {
      document.querySelectorAll(NATIVE_SLIDERS).forEach(function (el) { wireDrag(el, true); });
    }
    if (typeof ResizeObserver === 'undefined') return;
    if (!sizeWatch) {
      sizeWatch = new ResizeObserver(function (entries) {
        entries.forEach(function (en) { wireDrag(en.target); });
      });
    }
    els.forEach(function (sw) {
      if (sw.dataset.clWatch === '1') return;
      sw.dataset.clWatch = '1';
      sizeWatch.observe(sw);
      var wrap = sw.querySelector('.swiper-wrapper');
      if (wrap) sizeWatch.observe(wrap);
    });
  }

  /* -------------------------------------------------- popup Fair Pricing */
  function onFairPricing(e) {
    var open = e.target.closest && e.target.closest('[data-kv-price-fairly-open]');
    if (open) {
      var host = open.closest('.cl-pdp-part, .product-single__meta') || document;
      var popup = host.querySelector('.kv-no-designer-markup-popup') ||
                  document.querySelector('.kv-no-designer-markup-popup');
      if (!popup) return;
      e.preventDefault();
      popup.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      return;
    }
    var pop = e.target.closest && e.target.closest('.kv-no-designer-markup-popup');
    if (!pop) return;
    // fecha no X ou clicando fora da caixa
    if (e.target.closest('.kv-close-popup-icon') || !e.target.closest('.kv-no-designer-markup-popup-in')) {
      pop.style.display = 'none';
      document.body.style.overflow = '';
    }
  }

  /* ----------------------------------------------------- popup Size Guide
     `.kv-custom-size-guide-popup` nasce `display:none` (CSS do concorrente) e
     `.kv-custom-size-guide-main` com `style="display:none"` inline — os dois
     precisam abrir. As tabelas EU / US / UK trocam por `.kv-size-chart-active`. */
  function onSizeGuide(e) {
    var t = e.target;
    if (!t.closest) return;

    var tab = t.closest('.kv-size-chart-tab[data-tab]');
    if (tab) {
      e.preventDefault();
      var box = tab.closest('.kv-custom-size-chart') || document;
      var key = tab.getAttribute('data-tab');
      box.querySelectorAll('.kv-size-chart-tab').forEach(function (b) {
        b.classList.toggle('kv-size-chart-active', b === tab);
      });
      box.querySelectorAll('[data-kv-tab-panel]').forEach(function (p) {
        p.classList.toggle('kv-size-chart-active', p.getAttribute('data-kv-tab-panel') === key);
      });
      return;
    }

    var open = t.closest('.kv-custom-size-guide');
    if (open && !t.closest('.kv-custom-size-guide-popup')) {
      var popup = (open.closest('.kv-size-type-selector') || document)
                    .querySelector('.kv-custom-size-guide-popup') ||
                  document.querySelector('.kv-custom-size-guide-popup');
      if (!popup) return;
      e.preventDefault();
      popup.style.display = 'block';
      popup.querySelectorAll('.kv-custom-size-guide-main').forEach(function (m) {
        m.style.display = 'block';
      });
      document.body.style.overflow = 'hidden';
      return;
    }

    var pop = t.closest('.kv-custom-size-guide-popup');
    if (!pop) return;
    if (t.closest('.kv-size-close-icon') || !t.closest('.kv-custom-size-guide-popup-in')) {
      pop.style.display = 'none';
      document.body.style.overflow = '';
    }
  }

  /* ---------------------------------------------------- "Learn more about:"
     As ancoras do concorrente existem nas nossas secoes, menos a de reviews
     (`#judgeme_product_reviews`): a nossa loja usa outro app. Cai no bloco de
     avaliacoes que existir. */
  function onJumpClick(e) {
    var a = e.target.closest && e.target.closest('.jump_to_block a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    var target = document.getElementById(id);
    if (!target && /review|judgeme/i.test(id)) {
      target = document.querySelector('[id*="areviews"], [id*="review"]');
    }
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ------------------------------------------- quiz "Find my perfect size"
     4 passos (marca -> tamanho -> caimento -> largura) e um painel de
     resultado. A recomendacao e o tamanho EU informado, corrigido pelo
     caimento (aperta -> +1, folga -> -1) e pela largura do pe (largo -> +1). */
  var QUIZ = { brand: null, eu: null, gender: 'women', fit: null, width: null, step: 0 };
  var FIT_DELTA = { tight: 1, perfect: 0, loose: -1 };
  var WIDTH_DELTA = { narrow: 0, normal: 0, wide: 1 };
  var BRANDS = /Birkenstock|New Balance|Nike|Adidas|Skechers/g;

  function quizRoot() { return document.querySelector('.kv-multi-popups-root'); }

  function steps(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.kv-multi-popups-step'));
  }

  function showStep(i) {
    var root = quizRoot(); if (!root) return;
    steps(root).forEach(function (s, k) {
      var on = k === i;
      s.hidden = !on;
      s.classList.toggle('kv-multi-popups-step-active', on);
    });
    root.querySelectorAll('.kv-multi-popups-dot').forEach(function (d, k) {
      d.classList.toggle('kv-multi-popups-dot-active', k === i);
      d.classList.toggle('kv-multi-popups-dot-done', k < i);
    });
    QUIZ.step = i;
  }

  function showPanel(which) {
    var root = quizRoot(); if (!root) return;
    var stepsPanel = root.querySelector('.kv-multi-popups-panel-steps');
    var result = root.querySelector('.kv-multi-popups-panel-result');
    if (stepsPanel) stepsPanel.hidden = which !== 'steps';
    if (result) result.hidden = which !== 'result';
  }

  function quizOpen(open) {
    var root = quizRoot();
    if (!root) return;
    root.style.display = open ? 'flex' : 'none';
    var ov = root.querySelector('.kv-multi-popups-overlay');
    var modal = root.querySelector('.kv-multi-popups-modal');
    if (ov) ov.style.opacity = open ? '1' : '0';
    if (modal) {
      modal.style.opacity = open ? '1' : '0';
      modal.style.transform = open ? 'translateY(0)' : '';
    }
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) { showPanel('steps'); showStep(0); }
  }

  function recommend() {
    var base = parseInt(QUIZ.eu, 10);
    if (!isFinite(base)) return null;
    var eu = base + (FIT_DELTA[QUIZ.fit] || 0) + (WIDTH_DELTA[QUIZ.width] || 0);
    var conf = 92;
    if (QUIZ.fit && QUIZ.fit !== 'perfect') conf -= 4;
    if (QUIZ.width === 'wide') conf -= 3;
    if (QUIZ.brand && QUIZ.brand !== 'Birkenstock') conf -= 4;
    return { eu: eu, conf: Math.max(70, conf) };
  }

  /* Troca SO o texto, preservando os `<svg>` irmaos (o selo de confianca e a
     seta do botao vivem dentro dos mesmos elementos). */
  function setText(el, txt) {
    if (!el) return;
    for (var i = 0; i < el.childNodes.length; i++) {
      if (el.childNodes[i].nodeType === 3 && el.childNodes[i].nodeValue.trim()) {
        el.childNodes[i].nodeValue = txt;
        return;
      }
    }
    el.appendChild(document.createTextNode(txt));
  }

  var FIT_REASON = { tight: 'Your current shoes feel tight',
                     loose: 'Your current shoes feel loose',
                     perfect: 'Your current shoes fit you well' };

  function fillResult() {
    var root = quizRoot(); if (!root) return;
    var r = recommend(); if (!r) return;
    var size = root.querySelector('.kv-multi-popups-result-size');
    if (size) size.textContent = 'EU ' + r.eu;
    var conf = root.querySelector('.kv-multi-popups-confidence');
    if (conf) setText(conf, ' ' + r.conf + '% confidence');
    var reasons = root.querySelectorAll('.kv-multi-popups-reason-text');
    var texts = [
      QUIZ.brand && QUIZ.eu ? 'You wear ' + QUIZ.brand + ' EU' + QUIZ.eu : null,
      FIT_REASON[QUIZ.fit] || null,
      QUIZ.width ? 'Qomfort’s roomier footbed makes EU' + r.eu +
                   ' the better fit for your ' + QUIZ.width + ' feet' : null
    ];
    reasons.forEach(function (el, i) { if (texts[i]) el.textContent = texts[i]; });
    root.querySelectorAll('.kv-multi-popups-continue').forEach(function (b) {
      setText(b, 'Continue with EU' + r.eu + ' ');
      b.setAttribute('data-eu', r.eu);
    });
  }

  /* Aplica o tamanho recomendado no seletor de variante NATIVO do Shrine
     (pills ou dropdown). Sem isto o "Continue with EU44" so fecharia o modal. */
  function matchesEu(value, eu) {
    var m = parseSize(value);
    if (m) return String(m[1]).trim().split('/')[0] === String(eu);
    return String(value).trim() === String(eu);
  }

  function applySize(eu) {
    var picked = false;
    document.querySelectorAll('.product-form__input input[type="radio"]').forEach(function (input) {
      if (picked || !matchesEu(input.value, eu)) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      picked = true;
    });
    if (picked) return true;
    document.querySelectorAll('.product-form__input select').forEach(function (sel) {
      if (picked) return;
      for (var i = 0; i < sel.options.length; i++) {
        if (!matchesEu(sel.options[i].value, eu)) continue;
        sel.selectedIndex = i;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        picked = true;
        return;
      }
    });
    return picked;
  }

  function mark(el, sel, cls) {
    var scope = quizRoot() || document;
    scope.querySelectorAll(sel).forEach(function (x) { x.classList.toggle(cls, x === el); });
  }

  function onQuizClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('.kv-multi-popups-open-btn')) { e.preventDefault(); quizOpen(true); return; }
    var root = quizRoot();
    if (!root || root.style.display === 'none' || !root.contains(t)) return;

    if (t.closest('.kv-multi-popups-close') || t.closest('.kv-multi-popups-overlay')) {
      e.preventDefault(); quizOpen(false); return;
    }

    var brand = t.closest('[data-brand]');
    if (brand) {
      e.preventDefault();
      QUIZ.brand = brand.getAttribute('data-brand');
      mark(brand, '[data-brand]', 'kv-multi-popups-option-selected');
      root.querySelectorAll('.kv-multi-popups-question').forEach(function (q) {
        q.textContent = q.textContent.replace(BRANDS, QUIZ.brand);
      });
      showStep(1);
      return;
    }
    var gender = t.closest('.kv-multi-popups-gender button, .kv-multi-popups-gender label');
    if (gender) {
      e.preventDefault();
      QUIZ.gender = (gender.textContent || '').trim().toLowerCase().charAt(0) === 'm' ? 'men' : 'women';
      mark(gender, '.kv-multi-popups-gender button, .kv-multi-popups-gender label',
           'kv-multi-popups-option-selected');
      return;
    }
    var size = t.closest('.kv-multi-popups-size-btn');
    if (size) {
      e.preventDefault();
      QUIZ.eu = size.getAttribute('data-eu') || (size.textContent || '').trim();
      mark(size, '.kv-multi-popups-size-btn', 'kv-multi-popups-option-selected');
      showStep(2);
      return;
    }
    var fit = t.closest('[data-fit]');
    if (fit) {
      e.preventDefault();
      QUIZ.fit = (fit.getAttribute('data-fit') || '').toLowerCase();
      mark(fit, '[data-fit]', 'kv-multi-popups-option-selected');
      showStep(3);
      return;
    }
    var width = t.closest('[data-width]');
    if (width) {
      e.preventDefault();
      QUIZ.width = (width.getAttribute('data-width') || '').toLowerCase();
      mark(width, '[data-width]', 'kv-multi-popups-option-selected');
      fillResult();
      showPanel('result');
      return;
    }
    if (t.closest('.kv-multi-popups-retake')) {
      e.preventDefault(); showPanel('steps'); showStep(0); return;
    }
    var cont = t.closest('.kv-multi-popups-continue');
    if (cont) {
      e.preventDefault();
      applySize(cont.getAttribute('data-eu'));
      quizOpen(false);
      return;
    }
    var unit = t.closest('[data-unit], .kv-multi-popups-unit');
    if (unit) {
      e.preventDefault();
      mark(unit, '[data-unit], .kv-multi-popups-unit', 'kv-multi-popups-option-selected');
    }
  }

  /* ------------------------------------------------------------- arranque */
  function boot() {
    primeAccordions();
    primeVideoPosters();
    wireSliders();
    document.querySelectorAll('.product-form__input--pills, .product-form__input--dropdown')
      .forEach(wireSizePills);
    var q = currentQuantity();
    if (q) syncQuantity(q);
    var root = quizRoot();
    if (root && !root.style.display) root.style.display = 'none';
    document.querySelectorAll('.kv-no-designer-markup-popup').forEach(function (p) {
      if (!p.style.display) p.style.display = 'none';
    });
    if (bound) return;
    bound = true;
    document.addEventListener('click', onAccordionClick);
    document.addEventListener('click', onVideoClick);
    document.addEventListener('click', onFairPricing);
    document.addEventListener('click', onQuizClick);
    document.addEventListener('click', onUnitClick);
    document.addEventListener('click', onSizeGuide);
    document.addEventListener('click', onJumpClick);
    document.addEventListener('change', onQuantityChange);
    document.addEventListener('click', function (e) {
      // o clique no label so vira `change` depois; garantir o espelho
      if (e.target.closest && e.target.closest('.quantity-break, quantity-breaks label')) {
        setTimeout(function () { var q = currentQuantity(); if (q) syncQuantity(q); }, 0);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      quizOpen(false);
      document.querySelectorAll('.kv-no-designer-markup-popup, .kv-custom-size-guide-popup')
        .forEach(function (p) { p.style.display = 'none'; });
      document.body.style.overflow = '';
    });
    // um carrossel que CABE no desktop passa a transbordar quando a janela
    // encolhe — re-tentar o arrasto no resize
    window.addEventListener('resize', function () {
      primeAccordions();
      wireSliders();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // as fotos dos cards chegam depois do DOMContentLoaded e mudam a largura util
  window.addEventListener('load', wireSliders);
  document.addEventListener('shopify:section:load', boot);
})();
